/* eslint-disable no-console */
/* eslint-disable no-debugger */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import moment from "moment";
import _ from "lodash";
import { PROXY_URL, SESSION_TOKEN_KEY, SESSION_AUTH_KEY } from "./constants";
import { runDxpContinueRegistration } from "./dxpContinueRegistration";

export const getCompanyPageMessage = (props: any) => {
  let text = "";
  if (props.noOfCompanies === 0) {
    text = `You entered <b>${props.email}</b>.<br/> We couldn't find this address or company domain. Choose an option below:`;
  } else {
    text = `You entered ${props.email}.<br/> We found ${props.noOfCompanies} companies associated with this email domain.`;
  }

  return text;
};

export const getAddAdobeIdMessage = (props: any) => {
  const text = `Enter the Adobe ID associated with your company email address, ${props.email}.<br/> If you don't have an Adobe ID associated with this email address, you can create one now.`;
  return text;
};

export const getDxpCompanyPageMessage = (props: any) => {
  const text = `You entered <b>${props.email}</b>. We found <b>${props.noOfCompanies}</b> companies connected to this email domain. Please select the appropriate company from the list below.`;
  return text;
};

export const getDxpAddAdobeIdMessage = (props: any) => {
  let text = "";
  if (props.imsProfileExists) {
    text = `Great news! Our records indicate that you've previously created an Adobe account.<br/><br/> Please sign in to your Adobe account using this email address to connect your Adobe account with your partner program registration.`;
  } else {
    text = `It looks like you haven't previously created an Adobe ID with this email address.<br/><br/> Please click Create my Adobe ID to register for your Adobe ID.`;
  }
  return text;
};

export const downloadTermsAndCondition = (id: string) => {
  const input: any = document.getElementById(id);
  return input;
};

export const getCommonAPIHeaders = (isAuthHeaderNeeded = true) => {
  const headers = new Headers();
  headers.append("x-api-key", "exchange_spr");
  headers.append("Content-Type", "application/json");
  if (isAuthHeaderNeeded) {
    let tokenData: any = sessionStorage.getItem(SESSION_TOKEN_KEY);
    if (tokenData) {
      tokenData = JSON.parse(tokenData);
      if (tokenData?.tokenValue) {
        const tokenValue = `Bearer ${tokenData.tokenValue}`;
        headers.append("Authorization", tokenValue);
      }
    }
  }

  return headers;
};

export const getTemplateId = (templateName: string) => {
  const programType = localStorage.getItem("programType") || "mxp";
  return `${programType}-${templateName}`;
};

export const formatDate = (date: string, format: string) =>
  moment(date, "DD-MM-YYYY").format(format);

export const removeAuthHeader = (data: any) => {
  if (data) {
    const jsonData = JSON.parse(JSON.stringify(data));
    if (jsonData?.apiHeaders) {
      const headers = jsonData.apiHeaders.filter(
        (element: any) => element.name !== "Authorization",
      );
      jsonData.apiHeaders = headers;
    }
    return jsonData;
  }
  return {};
};

export const isProxyURL = () =>
  PROXY_URL.includes(window.location.href.split("/")[2]);

export const getTemplatePath = (_pathName: string) => "/";

/**
 * Returns the current program - DXP only
 */
export const getProgramFromUrl = () => "DXP";

export const getUserData = () => {
  const sessionData = sessionStorage.getItem(SESSION_AUTH_KEY);
  if (!sessionData) return null;
  try {
    return JSON.parse(sessionData) as { email?: string } | null;
  } catch {
    return null;
  }
};

/**
 * function converts a Nested object into a flattened object
 * @param obj - Nested objec
 * @param separator - string
 * @param parentKey - string
 * @returns flattend object
 */
export const flattenWithSeparator = (
  obj: any,
  separator = "_",
  parentKey = "",
) => {
  const result: any = {};

  for (const key in obj) {
    const newKey = parentKey ? parentKey + separator + key : key;
    // check if the field is an object then run a Recursive function
    // but preserve arrays as they are (don't flatten them)
    if (
      typeof obj[key] === "object" &&
      obj[key] !== null &&
      !Array.isArray(obj[key])
    ) {
      Object.assign(result, flattenWithSeparator(obj[key], separator, newKey));
    } else {
      // otherwise return the value with the field (including arrays)
      result[newKey] = obj[key];
    }
  }

  return result;
};

// Function to convert the flattened object back to the original nested format using Lodash
export const unflattenWithSeparator = (obj: any, separator = "_") =>
  _.transform(
    obj,
    (result, value, key: any) => {
      const keys = key.split(separator);
      keys.reduce((acc: any, currentKey: any, index: any) => {
        if (index === keys.length - 1) {
          acc[currentKey] = typeof value === "string" ? value.trim() : value;
        } else {
          acc[currentKey] = acc[currentKey] || {};
          return acc[currentKey];
        }
      }, result);
    },
    {},
  );

/**
 * gets the account id if it matched in the list
 * @param accId - Account ID to be searched
 * @param accounts - list of accounts
 * @returns account id if found else false
 */
export const getAccountIdFromList = (accId: string, accounts: any) => {
  const foundObject = _.find(accounts, { id: accId });
  if (foundObject) {
    return foundObject.id;
  }
  return false;
};

/**
 * As part of new flow (EC - SPP/DPP), id will be sent in id, old flow (DC) will have id in recId
 */
export const getAccountId = (account: any) => account?.id || account?.recId;

/**
 * Partner level from find-partner / company list API items.
 * Backend field names have varied (`level`, `partnerLevel`, etc.).
 */
export const getCompanyPartnerLevel = (account: unknown): string => {
  if (account == null || typeof account !== "object") return "";
  const a = account as Record<string, unknown>;
  const nestedCompanyInfo = a.companyInfo;
  if (nestedCompanyInfo != null && typeof nestedCompanyInfo === "object") {
    const fromNested = getCompanyPartnerLevel(nestedCompanyInfo);
    if (fromNested) return fromNested;
  }
  const candidates = [
    a.level,
    a.accountLevel,
    a.partnerLevel,
    a.partnershipLevel,
    a.membershipLevel,
    a.programLevel,
    a.partner_level,
    a.membershipType,
    a.membership_type,
  ];
  const resolved = candidates
    .map((value) => (value == null ? "" : String(value).trim()))
    .find((trimmed) => trimmed.length > 0);
  return resolved ?? "";
};

/** Save partner level for the success page (survives localStorage.clear on submit). */
export const persistPartnerLevel = (account: unknown): void => {
  const level = getCompanyPartnerLevel(account);
  if (!level) return;
  localStorage.setItem("membershipType", level);
  sessionStorage.setItem("dxpSelectedCompanyLevel", level);
};

/** Partner level from storage during registration. */
export const getStoredMembershipType = (): string => {
  const fromLocal = localStorage.getItem("membershipType");
  if (fromLocal?.trim()) return fromLocal.trim();
  const fromSession = sessionStorage.getItem("dxpSelectedCompanyLevel");
  if (fromSession?.trim()) return fromSession.trim();
  try {
    const raw = sessionStorage.getItem("registrationFormData");
    if (!raw) return "";
    const data = JSON.parse(raw) as Record<string, unknown>;
    const level = data.membershipInfo_membershipType ?? data.companyInfo_level;
    return level == null ? "" : String(level).trim();
  } catch {
    return "";
  }
};

/** API `primaryBusiness` values → labels shown in company picker (matches company form options). */
const PRIMARY_BUSINESS_API_TO_DISPLAY: Record<string, string> = {
  technology: "ISV/Data Provider",
  solution: "Consulting/Professional Services",
};

/**
 * Maps account `primaryBusiness` from the API to the user-facing label.
 * Known values: Technology → ISV/Data Provider, Solution → Consulting/Professional Services.
 */
export const mapPrimaryBusinessApiToDisplay = (
  apiValue: string | undefined | null,
): string => {
  if (apiValue == null) return "";
  const trimmed = String(apiValue).trim();
  if (!trimmed) return "";
  const mapped = PRIMARY_BUSINESS_API_TO_DISPLAY[trimmed.toLowerCase()];
  return mapped ?? trimmed;
};

/**
 * Find-partner API `accounts[]` items use flat fields: `countryName`, `country`, `primaryBusiness`.
 */
export const formatCompanySelectAccountInfo = (raw: unknown): string => {
  if (raw == null || typeof raw !== "object") return "";
  const a = raw as {
    countryName?: string | null;
    country?: string | null;
    primaryBusiness?: string | null;
  };
  const country =
    (a.countryName && String(a.countryName).trim()) ||
    (typeof a.country === "string" ? a.country.trim() : "") ||
    "";
  const business = mapPrimaryBusinessApiToDisplay(a.primaryBusiness);
  if (country && business) return `${country} | ${business}`;
  if (country) return country;
  if (business) return business;
  return "";
};

export const getDXPBasePath = () => {
  const basePaths = window.location.pathname.split("/s/")[0];
  if (basePaths) {
    return `${window.location.pathname.split("/s/")[0]}/s/registration`;
  }
  return `${window.partnerRegistrationConfig?.dxpBasepath ?? ""}/registration`;
};

/**
 * Gets the DXP registration redirect link
 * @returns The full registration URL for redirect purposes
 */
export const getDXPRegistrationLink = () =>
  `${window.location.origin}${window.location.pathname?.split("registration")[0]}registration`;

/**
 * Gets the support case form link
 * @returns The full URL to the support case form
 */
export const getSupportCaseLink = () =>
  `${window.location.origin}/digitalexperience/m/forms/case`;

/**
 * Common click handler for DXP confirmation pages
 * Handles various action types like email, chat, navigation, etc.
 * @param clickProps - Click event properties containing actionType and other data
 * @param customHandlers - Optional custom handlers for specific action types
 */
export const createDxpClickHandler =
  (customHandlers?: any) => (clickProps: any) => {
    const { actionType = "" } = clickProps || {};

    // Check for custom handler first
    if (customHandlers && customHandlers[actionType]) {
      customHandlers[actionType](clickProps);
      return;
    }

    // Default handlers for common action types
    switch (actionType) {
      case "email":
        window.open(getSupportCaseLink(), "_blank");
        break;

      case "chat":
        window.feds?.services?.jarvis?.openChat();
        break;

      case "goToRegistrationPage":
        getUserData();
        localStorage.removeItem("emailMismatch");
        localStorage.removeItem("partnerRegistrationFormStep");
        window.open(getDXPRegistrationLink(), "_self");
        break;

      case "DXPHomePage":
        localStorage.removeItem("emailMismatch");
        localStorage.removeItem("partnerRegistrationFormStep");
        window.open(`${window.location.origin}/digitalexperience/`, "_self");
        break;

      case "SignInToDXPHomePage":
        localStorage.removeItem("emailMismatch");
        localStorage.removeItem("partnerRegistrationFormStep");
        localStorage.setItem("redirectTo", "DXPHomePage");
        window.adobeIMS?.signIn();
        break;

      case "continueRegistration":
        runDxpContinueRegistration({ getUserData, getDXPRegistrationLink });
        break;

      case "continue":
        {
          const sessionData = sessionStorage.getItem(SESSION_AUTH_KEY);
          const { email } =
            typeof sessionData === "string"
              ? JSON.parse(sessionData)
              : sessionData || {};
          if (email) localStorage.setItem("emailMismatch", email);
          localStorage.removeItem("accountId");
          localStorage.removeItem("companyName");
          localStorage.removeItem("partnerRegistrationFormStep");
          window.open(getDXPRegistrationLink(), "_self");
        }
        break;

      case "goBack":
        localStorage.removeItem("accountId");
        localStorage.removeItem("companyName");
        localStorage.removeItem("email");
        localStorage.removeItem("emailMismatch");
        localStorage.removeItem("partnerRegistrationFormStep");
        localStorage.removeItem("RedirectPath");
        window.adobeIMS?.signOut?.({
          redirect_uri: getDXPRegistrationLink(),
        });
        break;

      case "contactSupport":
        window.open(getSupportCaseLink(), "_blank");
        break;

      default:
        break;
    }
  };

/**
 * Creates lifecycle hooks for DXP confirmation pages
 * @param customHandlers - Optional custom handlers for specific action types
 * @returns Lifecycle hooks object with onSuccessCallbacks
 */
export const createDxpLifecycleHooks = (customHandlers?: any) => {
  const onHandleClick = createDxpClickHandler(customHandlers);

  return {
    onSuccessCallbacks: {
      hyperLink: { onHandleClick },
      button: { onHandleClick },
    },
  };
};
